// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  territoryKey: __t.string().primaryKey().name("territory_key"),
  kind: __t.string(),
  guildId: __t.u64().name("guild_id"),
  worldId: __t.u64().name("world_id"),
  x: __t.f64(),
  z: __t.f64(),
  tier: __t.u32(),
  radius: __t.f32(),
  upkeepDueAt: __t.timestamp().name("upkeep_due_at"),
  upkeepNote: __t.string().name("upkeep_note"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
